module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('index-topbar'), _vm._v(" "), _c('swiper'), _vm._v(" "), _c('div', {
    staticClass: "router"
  }, [_c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/classify"
    }
  }, [_c('a', {
    staticClass: "routerImg classifyBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "分类"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("分类")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/rank"
    }
  }, [_c('a', {
    staticClass: "routerImg rankBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "排行"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("排行")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/women"
    }
  }, [_c('a', {
    staticClass: "routerImg womenBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "女区"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("女区")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/men"
    }
  }, [_c('a', {
    staticClass: "routerImg menBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "男区"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("男区")])], 1), _vm._v(" "), _c('div', {
    staticClass: "routerBtn"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/booklist"
    }
  }, [_c('a', {
    staticClass: "routerImg listBtn",
    style: ({
      backgroundImage: 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "href": "javascript:void(0);",
      "title": "书单"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("书单")])], 1)]), _vm._v(" "), _c('index-content'), _vm._v(" "), _c('index-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6af59672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/home/index.vue
// module id = 189
// module chunks = 1